export default "<ng4-loading-spinner> </ng4-loading-spinner>\n<router-outlet></router-outlet>\n"